import { action, makeObservable } from 'mobx';
import { Store } from '../../../store/store';
import { StoreNode } from '../../../store';
import { ForgotPasswordFormState } from './forgotPasswordFormState';

export class ForgotPasswordPageState
  extends StoreNode {

  constructor(store: Store) {
    super(store);
    makeObservable(this, {
      attached: action,
      detached: action,
    });
  }

  readonly form = new ForgotPasswordFormState(this.store);

  attached() { /* noop */ }

  detached() {
    this.form.reset();
  }
}